import React, { createContext, useContext } from 'react';
import { notification } from 'antd';

// ToastContext 생성
const ToastContext = createContext();

// ToastProvider 컴포넌트
export const ToastProvider = ({ children }) => {
  const showToast = (
    description,
    placement = 'bottom',
    duration = 3,
    onClose,
    key,
  ) => {
    notification.open({
      description: <span>{description}</span>,
      onClose,
      duration,
      closeIcon: null,
      placement,
      key: key || `${description}`,
      className: 'occ-toast flex align-center justify-center',
      rtl: true,
    });
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
    </ToastContext.Provider>
  );
};

// useToast 훅
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useMessage must be used within a ToastProvider');
  }
  return context;
};
